import { frontendURL } from '../../../helper/URLHelper';
import CommercialDashboard from './Index.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/commercial-dashboard'),
    name: 'commercial_dashboard_index',
    component: CommercialDashboard,
    meta: {
      permissions: ['administrator'],
    },
  },
];
